module.exports = __webpack_public_path__ + "static/bert-e8185b951a04878ad54c8ce13ef65615.jpg";